export default __webpack_public_path__ + "static/media/Java.81a901a4.jfif";